import { useActiveDisclaimer } from '@/components/base/Header/components/Disclaimer/hooks/useActiveDisclaimer';
import { usePageBannerConfig } from '@/components/base/Layout/PageBanner/hooks/usePageBannerConfig';

const DISCLAIMER_HIDE_OFFSET = '30rem';
const NO_OFFSET = '0rem';
const BANNER_HIDE_OFFSET =
  'calc(var(--ces-header-profile-section-height) + var(--ces-header-navigation-tabs-height))';

export function usePageOffset(): string {
  const Disclaimer = useActiveDisclaimer();
  const { isSticky, dynamicHeight } = usePageBannerConfig();

  if (isSticky && dynamicHeight) {
    return BANNER_HIDE_OFFSET;
  }

  return Disclaimer && !isSticky ? DISCLAIMER_HIDE_OFFSET : NO_OFFSET;
}
